__turbopack_context__.v({
  "box1": "GardenLoadingIndicator-module-scss-module__MoDa2q__box1",
  "box2": "GardenLoadingIndicator-module-scss-module__MoDa2q__box2",
  "box3": "GardenLoadingIndicator-module-scss-module__MoDa2q__box3",
  "box4": "GardenLoadingIndicator-module-scss-module__MoDa2q__box4",
  "boxes": "GardenLoadingIndicator-module-scss-module__MoDa2q__boxes",
});
